import { useLoaderData } from "react-router-dom";
import { redirect } from "react-router-dom";
import { motion } from "framer-motion";
import { HiUsers, HiExclamationTriangle } from "react-icons/hi2";

import Account from "./Account";
import adminUi from "../UI/AdminUi.module.css";
import { getAllAccounts } from "../../api/api";
import { getAuthToken } from "../../util/authToken";

const listParent = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.07, delayChildren: 0.04 },
  },
};

const listItem = {
  hidden: { opacity: 0, y: 18 },
  show: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 380, damping: 28 },
  },
};

function sortUsersNewestFirst(users) {
  return [...users].sort((a, b) => String(b._id).localeCompare(String(a._id)));
}

const Accounts = () => {
  const res = useLoaderData();
  const accounts = sortUsersNewestFirst(res?.data?.users ?? []);

  return (
    <div className={adminUi.page}>
      <h1 className={adminUi.pageTitle}>
        <HiUsers className={adminUi.pageTitleIcon} aria-hidden />
        Customer accounts
      </h1>
      <p className={adminUi.pageLead}>
        Review balances, update details, and manage access for client accounts.
      </p>
      {res.status !== "success" && res.message && (
        <p className={adminUi.loadError} role="alert">
          <HiExclamationTriangle
            className={adminUi.loadErrorIcon}
            aria-hidden
          />{" "}
          {res.message}
        </p>
      )}
      <motion.section
        className={adminUi.gridCards}
        variants={listParent}
        initial="hidden"
        animate="show"
      >
        {accounts.map((el) => (
          <motion.div key={el._id} variants={listItem}>
            <Account
              id={el._id}
              name={el.name}
              username={el.username}
              email={el.email}
              photo={el.photo}
              account={el.accountNumber}
              balance={el.balance}
              status={el.active}
            />
          </motion.div>
        ))}
      </motion.section>
    </div>
  );
};

export default Accounts;

export const loader = async () => {
  const jwt = getAuthToken();
  if (!jwt) {
    throw redirect("/login");
  }
  return getAllAccounts(jwt);
};
